<template>
    <footer>


    </footer>
</template>

<script>

    export default {
        name: 'Footer'
    }
</script>



// WEBPACK FOOTER //
// Footer.vue?23f7e884